<template>
  <div class="py-4">
    <template v-if="type !== 'date' && allItems.length > 0 && !loading">
      <div
        :style="
          isSmallDevice
            ? `max-height: calc(100vh - 429px);`
            : `max-height: calc(100vh - 460px);`
        "
        class="scroll-content container"
      >
        <div class="available-bar">
          <button
            class="btn btn-success text-white"
            @click="selectAny"
            v-if="
              (type == 'location' ||
                type == 'placeOfService' ||
                type == 'clinician') &&
                allItems.length > 0
            "
          >
            Any available
            {{ type === "placeOfService" ? "location" : type }}
            <b-icon icon="chevron-double-right"></b-icon>
          </button>
        </div>

        <div
          v-for="item in allItems"
          :key="item.id"
          class="item-card d-flex justify-content-between align-items-center mt-4 p-4 mb-4"
        >
          <div class="d-flex flex-column">
            <span class="option-title">
              {{ item.title || item.name }}
            </span>
            <span v-if="item.duration && item.duration > 0">
              {{
                item.duration > 1
                  ? item.duration + ` minutes`
                  : item.duration + ` minute`
              }}
            </span>
            <span v-if="item.address">
              {{ item.address }}
            </span>
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <button
              @click="select(item)"
              class="btn btn-primary text-uppercase"
            >
              Select
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        class="container d-flex justify-content-center align-items-center text-center h-50 flex-column"
      >
        <div v-if="loading">
          <b-spinner
            style="width: 4rem; height: 4rem"
            variant="primary"
            label="Loading..."
          />
        </div>

        <div v-else>
          <h3>{{ getIsEmptyMessage }}</h3>

          <b-button
            class="mt-5"
            size="md"
            variant="primary"
            @click="goBack"
            style="width: 100px;"
          >
            Go back
          </b-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "SingleSelectorStep",
  props: ["value", "type", "existingPatient", "isGoinBack", "loading"],
  data() {
    return {
      selectedDate: null
    };
  },

  methods: {
    select(item) {
      this.$emit("select", item);
    },
    selectAny() {
      this.$emit("selectAny");
    },
    goBack() {
      this.$emit("back");
    }
  },
  computed: {
    allItems: {
      get: function() {
        return this.value.map(item => {
          return {
            ...item,
            selected: false,
            type: this.type
          };
        });
      }
    },
    isSmallDevice() {
      return window.innerWidth < 576 ? true : false;
    },
    getIsEmptyMessage() {
      switch (this.type) {
        case "clinician":
          return "No clinicians available, please change your selection and try again.";
        case "placeOfService":
          return "No place of service available, please change your selection and try again.";
        case "location":
          return "No locations available, please change your selection and try again.";
        case "service":
          return "No locations available, please change your selection and try again.";
        default:
          return "Sorry, there's no item";
      }
    }
  },
  watch: {
    allItems: function(value) {
      if (
        value.length == 1 &&
        this.type == "service" &&
        !this.existingPatient &&
        !this.isGoinBack
      ) {
        this.select(value[0]);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.item-card {
  background-color: #fff;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -moz-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  color: #808080;
  min-width: 260px;
  overflow: hidden;
  position: relative;
}

.scroll-content {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  overflow: auto;
}

.scroll-content::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #dfe6e9;
}

.scroll-content::-webkit-scrollbar-thumb {
  background-color: #2196f3;
  border-radius: 10px;
}

.option-title {
  font-size: 20px;
  overflow-wrap: break-word;
}
.available-bar {
  display: flex;
  justify-content: flex-end;
}
@media screen and (max-width: 576px) {
  .option-title {
    font-size: 16px;
  }
}
</style>
